<template>
    <div class="dashboard-layout" :style="{'column-count': columnCount}">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "DashboardLayout",
        props: {
            columnCount: Number
        },
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-layout {
        column-gap: 20px;
        margin-bottom: 20px;
        -webkit-column-break-inside: avoid;
        break-inside: avoid;
        break-after: right;
    }

</style>